<template>
  <el-dialog :title="title" :visible.sync="visible" width="30%" @open="handleOpen">
    <el-row :gutter="20">
      <el-col>
        <el-form :model="repoForm" label-width="100px">
          <el-form-item label="课程类别:">
            <el-select
              v-model="repoForm.courseId"
              placeholder="请选择课程类别"
              style="width: 80%"
              clearable>
              <el-option
                v-for="category in courseCategories"
                :key="category.id"
                :label="category.name"
                :value="category.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="题库名称:">
            <el-input
              v-model="repoForm.repoTitle"
              autocomplete="off"
              style="width: 80%"
              placeholder="如 AMC8、袋鼠数学LEVEL1"
            />
            <div style="color: #909399; font-size: 12px; line-height: 1.5; margin-top: 4px;">
              命名规则：题库名称应与课程级别名称保持一致，系统会根据题库名称匹配课程。<br/>
              示例：AMC8、AMC10、袋鼠数学LEVEL1、CCF-GESP LEVEL1 等。
            </div>
          </el-form-item>
          <el-form-item label="题库类型:">
            <el-select v-model="repoForm.questionType" placeholder="请选择题库类型" style="width: 80%" clearable>
              <el-option label="普通题库" value="normal" />
              <el-option label="GESP编程题库" value="gesp_code" />
            </el-select>
          </el-form-item>
          <el-form-item label="是否开启刷题:">
            <el-switch
              v-model="repoForm.isExercise"
              active-color="#13ce66"
              inactive-color="#cccccc"
            />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getCourseCategories } from '@/api/course'

export default {
  components: {},
  props: {
    title: {
      type: String,
      default: '提示'
    },
    value: {
      type: Boolean,
      default: false
    },
    updateData: {
      type: Object,
      default() {
        return {
          title: '',
          isExercise: 0
        }
      }
    },
    onConfirm: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      repoForm: {
        repoTitle: '',
        isExercise: false,
        courseId: null,
        questionType: 'normal'
      },
      visible: this.value,
      courseCategories: []
    }
  },
  watch: {
    value(val) {
      this.visible = val
    },
    updateData(val) {
      this.repoForm.repoTitle = val.title
      this.repoForm.isExercise = val.isExercise === 1
      this.repoForm.courseId = val.courseId || null
    },
    visible(val) {
      this.$emit('input', val)
    },
    updateData(val) {
      this.repoForm.repoTitle = val.title
      this.repoForm.isExercise = val.isExercise === 1
      this.repoForm.courseId = val.courseId || null
      this.repoForm.questionType = val.questionType || 'normal'
    }
  },

  methods: {
    handleOpen() {
      this.loadCourseCategories()
    },
    async loadCourseCategories() {
      try {
        const res = await getCourseCategories()
        if (res && res.code === 1) {
          this.courseCategories = res.data || []
        }
      } catch (error) {
        console.error('加载课程类别失败:', error)
      }
    },
    handleConfirm() {
      // 调用父组件传入的确认回调方法，并传递 repoForm 数据
      this.onConfirm(this.repoForm)
      // 关闭对话框
      this.visible = false
      this.repoForm = {
        repoTitle: '',
        isExercise: false,
        courseId: null
      }
    }
  }
}
</script>
<style></style>
